import { render, staticRenderFns } from "./PuzzleGame.vue?vue&type=template&id=6b87c3c8&scoped=true&"
import script from "./PuzzleGame.vue?vue&type=script&lang=js&"
export * from "./PuzzleGame.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleGame.vue?vue&type=style&index=0&id=6b87c3c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b87c3c8",
  null
  
)

export default component.exports